import React, { FC } from 'react';
import styled from 'styled-components';
import { font } from '../../../lib/sharedStyles';

interface TextInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  label: string;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  id: string;
  name: string;
  brand?: string;
}

export const StyledContainer = styled.div`
  width: 100%;
  min-width: 200px;
  margin-right: auto;
  margin-left: auto;
  position: relative;
`;

export const StyledLabel = styled.label`
  position: absolute;
  top: 16px;
  left: 10px;
  ${font('Instrument Sans', 400, '14px', '22px')}
  pointer-events: none;
  transition: 0.2s ease all;
  opacity: 0;
`;

export const StyledInput = styled.input<{ $brand?: string }>`
  width: 100%;
  padding: 16px 10px;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  background: transparent;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  outline: none;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  ${({ $brand }) => $brand == 'jackson' &&`
    border: .0625rem solid #e0e0e0;
    border-radius: 0;
  `}
`;

const TextInput: FC<TextInputProps> = ({
  value,
  onChange,
  label,
  onKeyPress = () => {},
  onKeyDown = () => {},
  id,
  name,
  brand,
}) => {
  return (
    <StyledContainer>
      <StyledLabel htmlFor={id}>
        {label}
      </StyledLabel>
      <StyledInput
        id={id}
        name={name}
        type="text"
        value={value}
        placeholder={label}
        onChange={onChange}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        $brand={brand}
      />
    </StyledContainer>
  );
};

export default TextInput;
